import { Component, OnInit } from '@angular/core';
import { Globals } from '../../shared/services/globals';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserData } from '../../shared/models/DTO/UserData';
import { UserService } from '../services/user.service';
import { GenericVm } from '../../shared/models/system/generic-vm';
import { MessageEnum } from '../../shared/models/system/message.enum';
import { Message } from '../../shared/models/system/message';;  
import { Role } from '../../shared/models/Com/Role';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { StudentDetailsComponent } from '../student-details/student-details.component';
import { Roles } from '../../shared/models/Com/ENUMS/Roles';


@Component({
  selector: 'app-user-view',
  templateUrl: './user-view.component.html',
  styleUrls: ['./user-view.component.css']
})
export class UserViewComponent implements OnInit {
  true=true;
  page = 1;
  pageSize = 10;
  userData:UserData[];
  userDataLength;
  addMessage;
  searchString;
  fileUploaded: File;  
  worksheet: any;  
  storeData: any;  
  filelist: any[];
  uploadedFileName: string;
  first_sheet_name: string;
  outputResult: any[]=[];
  roles: Role[]=[];
  role:string=null;
  key: any=null;
  clearSearch:boolean=false;
  roleId: any=null;
  selectedRole = null; 

  constructor(public userService: UserService, 
    public globals: Globals,
     private translate: TranslateService, 
     private router: Router,
     public dialog: MatDialog,
     private route: ActivatedRoute

     ) {

  }

  ngOnInit() {
    this.roleId = this.route.snapshot.paramMap.get('roleId');
    this.userData=[];
    if(this.roleId ==null){
      this.getUsers();
    }else{
      console.log(this.roleId)
      this.selectedRole=this.roleId;
      this.SearchUsers(null,this.roleId);
    }
    
 
    this.getRoles();
  }
  onPageChange(event) {
    this.page=event;
    if(this.key !=null || this.roles !=null){
      this.SearchUsers(this.key,this.role);
    }else{
      this.getUsers();
    }
  }

  getRoles(){
    this.userService.listRoles().subscribe((res: any) => {
      let result =res as GenericVm<Array<Role>>;
      if(result.status){
    //    this.globals.spinner=false;
        this.roles = result.data;
        console.log(this.roles)
      }else{
        this.globals.messages = result.messages;
      }
          
    },
    err=>this.roles=[]
    );
  }

  getUsers() {
    this.globals.spinner=true;
    this.userService.getUsers(this.page, this.pageSize).subscribe((res: any) => {
      let result =res as GenericVm<Array<UserData>>;
      if(result.status){
        this.globals.spinner=false;
        this.userData = result.data;
        this.userDataLength = result.dataLength;
      }else{
        this.globals.messages = result.messages;
      }
          
    },
    err=>{
      this.globals.messages = new Array();
        let message = new Message();
        message.type = MessageEnum.Error;
        this.translate.get('errors.server-not-available').subscribe((text: string) => message.body = text);
        this.globals.messages.push(message);
    }
    );
  }


  SearchUsers(key=null,role=null) {
    this.role=role;
    this.key=key;
    this.globals.spinner = true;
    if (typeof (key) == 'undefined' || key == null || key == '') {
      key=null
    }
    
      this.userService.searchUsers(key,role,this.page, this.pageSize).subscribe((res: any) => {

        let result =res as GenericVm<Array<UserData>>;
        if(result.status){
          this.globals.spinner=false;
          this.userData = result.data;
          this.userDataLength = result.dataLength;
        }else{
          this.globals.messages = result.messages;
        }
        if(key !=null || role!=null){
          this.clearSearch=true;
        } 
      },
      err=>{
        this.globals.messages = new Array();
          let message = new Message();
          message.type = MessageEnum.Error;
          this.translate.get('errors.server-not-available').subscribe((text: string) => message.body = text);
          this.globals.messages.push(message);
      });
    //}

  }
  openUserDetail(user:UserData){
    if(user.roleId==Roles.Student){
      let config=new MatDialogConfig();
    config.data={
      studentId:user.id,
      studentName:user.userName
    }
    this.dialog.open(StudentDetailsComponent,config);
    }else{

    }
    
  }
  cancelSearch(){
    this.role=null;
    this.key=null;
    this.page=1;
    this.clearSearch=false;
    this.getUsers();
  }
  }

